import angular from 'angular';
import { IApontamentoImportacaoArquivo } from '../models/apontamentosimportacao.model';

export class ApontamentosImportacaoModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) {}

    open(entity: IApontamentoImportacaoArquivo) {
        return this.$uibModal.open({
            template: require('html-loader!./apontamentosimportacao.importarmodal.html'),
            controller: 'ApontamentosImportacaoModalController',
            controllerAs: '$ctrl',
            windowClass: 'nsj-modal-lg-no-height',
            resolve: {
                entity: () => angular.copy(entity)
            },
        });
    }
}
